import * as React from 'react';

export function ProblemSection() {
  return (
    <section className="verdu-problem">
      <style>{`
        .verdu-problem {
          padding: 72px 24px;
          background: #fff;
        }
        .verdu-problem-inner {
          max-width: 720px;
          margin: 0 auto;
        }
        .verdu-problem h2 {
          font-size: 28px;
          font-weight: 800;
          color: #1a1a1a;
          margin: 0 0 8px;
          line-height: 1.3;
        }
        .verdu-problem .accent {
          font-size: 22px;
          font-weight: 600;
          color: #c53030;
          margin: 0 0 28px;
        }
        .verdu-problem p {
          font-size: 16px;
          color: #444;
          line-height: 1.7;
          margin: 0 0 20px;
        }
        .verdu-problem .highlight {
          font-weight: 600;
          color: #1a1a1a;
        }
        .verdu-fail-list {
          list-style: none;
          padding: 0;
          margin: 24px 0 0;
          display: grid;
          grid-template-columns: 1fr 1fr;
          gap: 12px;
        }
        .verdu-fail-list li {
          display: flex;
          align-items: center;
          gap: 10px;
          font-size: 15px;
          color: #555;
          padding: 10px 14px;
          background: #fef2f2;
          border-radius: 8px;
        }
        .verdu-fail-list li i {
          color: #c53030;
          font-size: 14px;
          flex-shrink: 0;
        }
        @media (max-width: 640px) {
          .verdu-problem h2 {
            font-size: 24px;
          }
          .verdu-fail-list {
            grid-template-columns: 1fr;
          }
        }
      `}</style>
      <div className="verdu-problem-inner">
        <h2>¿Seguís yendo al Mercado a reponer?</h2>
        <p className="accent">Hay una forma más inteligente de abastecer tu verdulería.</p>
        <p>
          Ir al Mercado de Abasto significa <span className="highlight">recorrer puesto por puesto,
          negociar precios, cargar cajones y perder medio día</span> antes de atender tu local.
          Los lunes, encima, hay que madrugar.
        </p>
        <p>
          Mientras tanto, tus competidores ya están vendiendo.
        </p>
        <p className="highlight">El modelo tradicional te cuesta más de lo que pensás:</p>
        <ul className="verdu-fail-list">
          <li><i className="fa fa-times-circle" /> Perder horas recorriendo puestos</li>
          <li><i className="fa fa-times-circle" /> Precios que cambian sin aviso</li>
          <li><i className="fa fa-times-circle" /> Cargar y transportar cajones</li>
          <li><i className="fa fa-times-circle" /> No estar en tu local cuando hay clientes</li>
        </ul>
      </div>
    </section>
  );
}
